import * as yup from 'yup';

export const schema = yup.object().shape({
  breeds: yup.array().max(2, 'Maximum of two breeds allowed'),
});
